import { FC } from 'react';
import { Avatar, Chip, Tooltip } from '@material-ui/core';
import { useGetExpiringShares } from 'client/hooks/videoExport/useGetExpiringShares';
import { useNavigate } from 'react-router-dom';

interface Props {}

export const ExpiringBadge: FC<Props> = () => {
    const { data, isLoading } = useGetExpiringShares();
    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/video-export?filter=expiring');
    };

    if (!data || data.length === 0 || isLoading) {
        return null;
    }

    const chipMessage = data.length > 1 ? 'Expiring shared procedures' : 'Expiring shared procedure';
    const tooltipMessage = (
        <>
            You have {data.length} expiring shared {data.length > 1 ? 'procedures' : 'procedure'}:
            <ul>
                {data.map(item => (
                    <li key={item.procedureid}>
                        Procedure {item.procedureid} expires on {new Date(item.expiration_date).toLocaleDateString()}.
                    </li>
                ))}
            </ul>
            Click to list all available expiring shared procedures.
        </>
    );

    return (
        <Tooltip title={tooltipMessage} arrow>
            <Chip
                avatar={
                    <Avatar style={{ backgroundColor: '#e18c88', fontWeight: 'bolder', color: 'black', fontSize: '1.2em' }}>{data.length}</Avatar>
                }
                label={chipMessage}
                style={{ backgroundColor: '#d2504b' }}
                onClick={handleClick}
            />
        </Tooltip>
    );
};
